import React from 'react';
import '../gral-stylesheets/footer.scss';
import { IconAndroid, IconBxlLinkedin, IconFacebook, IconGooglePlus, IconInstagram, IconTwitter } from '../icons/icons';



class Footer extends React.Component {
  render() {
    return (
      <div className='footer-container'>
        <div className='footer-text'>
          <div className='location-dearHR'>
            <h3>Plot 598~1146, Warehouse 1, Dubai Investment Park 1, Dubai, U.A.E</h3>
            <br />
            <br />
            <h4>Phone Number : +971 123 123 78</h4>
            <h4>Mobile: +971 0029 789 78</h4>
            <h4>for Support/Enquiries: info@dearhr.com</h4>
          </div>
          <div className='dearHR'>
            <h3>Dear HR</h3>
              <ul>
                <li><a href='#news-section'><h4>News</h4></a></li>
                <li><a href='#blogs-section'><h4>Blogs</h4></a></li>
                <li><a href='#feedback-section'><h4>Feedback</h4></a></li>
                <li><a href='#feedback-section'><h4>Contact Us</h4></a></li>
                <li><a href='#privacyPolicy-section'><h4>Privacy Policy</h4></a></li>
                <li><a href='#TermsOfService-section'><h4>Terms of Service</h4></a></li>
              </ul>
          </div>
          <div className='support'>
            <h3>Support</h3>
              <ul>
                <li><a href='#faqs-section'><h4>FAQ's</h4></a></li>
                <li><a href='#temes-section'><h4>Themes</h4></a></li>
                <li><a href='#account-section'><h4>Account</h4></a></li>
                <li><a href='#documentation-section'><h4>Documentation</h4></a></li>
                <li><a href='#supportForum-section'><h4>Support Forum</h4></a></li>
              </ul>
          </div>
        </div>
        <div className='footer-media'>
          <div className='social-media'>
            <h3>Follow Us</h3>
            <a href='#facebook-link' title='Our facebook'>
              <i>< IconFacebook /></i>
            </a>
            <a href='#twitter-link' title='Our twitter'>
              <i>< IconTwitter /></i>
            </a>
            <a href='#linkedin-link' title='Our linked In'>
              <i>< IconBxlLinkedin /></i>
            </a>
            <a href='#google-plus-link' title='Our google+'>
              <i>< IconGooglePlus /></i>
            </a>
            <a href='#instagram-link' title='Our instagram'>
              <i>< IconInstagram /></i>
            </a>
          </div>
          <div className='mobile-app'>
            <h3>Mobile app</h3>
            <a href='#google play-link' title='download DearHR App from Google Play'>
              <i><IconAndroid /></i>
            </a>
          </div>
        </div>
        <div className='footer-copyright'>
          <h5>Copyright 2022. C&S Fullstack-DIGITAL</h5>
        </div>
      </div>
    )
  }
}


export default Footer;